export default function getDietBalanceLabel(eats_meat?: boolean): string {
  if (eats_meat) {
    return 'With meat';
  } else if (eats_meat === false) {
    return 'Without meat';
  } else {
    return '--';
  }
}
